let retries = 0;

export const globalRetries = (): number => retries;

export const increaseGlobalRetries = (): void => {
  retries += 1;
};
